export default __webpack_public_path__ + "static/media/swap  default.5ba27d5a.svg";